export { default } from 'common/interfaces/duration';
